export default "__VITE_ASSET__DWmnFesD__"